import { Construction } from 'lucide-react';
import { useTranslation } from '../i18n';

export default function PlaceholderPage({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white px-8 py-20 text-center dark:border-slate-700 dark:bg-slate-800">
      <Construction className="mb-4 h-12 w-12 text-slate-300 dark:text-slate-600" />
      <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">{title}</h2>
      <p className="mt-2 max-w-md text-sm text-slate-600 dark:text-slate-400">
        {t('hub:placeholder.comingSoon')}
      </p>
    </div>
  );
}
